<template>
  <div class="examination-container">
    <div class="examination-table">
      <ul>
        <li v-for="item in examList" :key="item.examId">
          <a @click="toExam(item.examId)" href="javascript:;">{{item.examName}}</a>
        </li>
      </ul>
    </div>
    <div class="task-pagination" style="text-align: center;" v-show="listlength">
      <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="pageNum"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
    </div>
    <nothing v-show="!listlength"></nothing>
  </div>
</template>

<script>
  import nothing from '../../../common/nothing.vue'
  import {ApiGetMockExam} from '../../../net/exam/index.js'
  export default {
    data: function () {
      return {
        pageNum: 1,
        pageSize: 8,
        total: 0,
        loading: false,
        examList: [],
      }
    },
    components:{nothing},
    computed: {
      listlength: function () {
        return this.examList.length
      }
    },
    methods: {
      getLiveList: function () {
        const prames = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          platform: 'pc'
        }
        this.loading = true
        ApiGetMockExam(prames).then(res=>{
        //  console.log('模拟练习', res)
          if (res.code == 200) {
            this.examList = res.pc.details
            this.total = res.pc.total
          }
        })
      },
      handleCurrentChange: function (index) {
        this.pageNum = index
        this.getLiveList()
      },
      toLive: function (item) {
        const liveUrl = getLiveUrl(item.id)
        window.open(liveUrl, '_blank')
      },
      toLiveBack: function (item) {
        const { href } = this.$router.resolve({
              path: `liveBackPlayer`,
              query:{lid : item.id}
            });
        window.open(href, '_blank');
      },
      toExam: function (eid) {
        this.$router.push({
          path: '/ExamDetail',
          query: {eid, isMook: 1}
        })
      }
    },
    mounted: function () {
      this.getLiveList()
    }
  }
</script>

<style scoped>
.examination-container{
  width: 850px;
  float: right;
  background: #fff;
  border-radius: 6px;
  min-height: 600px;
  position: relative;
  }
.examination-table{
  padding:0 40px 20px;
}
.examination-container ul{
  margin:0;
  padding:0;
}
.examination-container ul li{
  list-style-type: none;
  padding:20px 0;
  border-bottom: 1px solid #e5e5e5;
}
.examination-container ul li a{
  font-size: 16px;
  color: #252525;
  font-weight: 400;
  text-decoration: none;
}

.task-pagination{
  text-align: center;
  position: absolute;
  bottom: 34px;
  width: 100%;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/AccExam/children/exammock.vue